import React, { Fragment, useState, useEffect } from "react";
import {
  Form,
  Input,
  Button,
  Layout,
  Row,
  Col,
  Card,
  Breadcrumb,
  message,
} from "antd";
import { Link, Redirect } from "react-router-dom";

import Axios from "axios";
import { url } from "../../config/global";
import moment from "moment";

const { Content } = Layout;

const layout = {
  labelCol: {
    lg: 8,
    md: 10,
  },
  wrapperCol: {
    lg: 8,
    md: 14,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};

function EditHistoryScanProduksi(props) {
  const [data, setData] = useState({
    item_number: "",
    qty: "",
    unit: "",
  });

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    Axios.get(`${url}/histori-scan-produksi/${props.match.params.id}`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        setData({
          ...data,
          item_number: res.data.data.item_number,
          qty: res.data.data.qty,
          unit: res.data.data.unit,
        });
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
          if (err.response.status === 401) {
            sessionStorage.removeItem("token");
          }
        }
      });
  };

  const handleChange = (name, value) => {
    setError(null);
    setData({
      ...data,
      [name]: value,
    });
  };

  const onSaveData = () => {
    setLoading(true);

    let fd = new FormData();
    fd.set("item_number", data.item_number);
    fd.set("qty", data.qty);
    fd.set("unit", data.unit);

    Axios.post(`${url}/histori-scan-produksi/${props.match.params.id}`, fd, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        message.success(res.data.message);
        props.history.push("/history-scan-produksi");
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
          if (err.response.status === 422) {
            setError(err.response.data.errors);
          }
          if (err.response.status === 401) {
            sessionStorage.removeItem("token");
          }
        }
        setLoading(false);
      });
  };

  const handleReset = () => {
    setData({
      item_number: "",
      qty: "",
      unit: "",
    });
  };

  if (!sessionStorage.getItem("token")) {
    return <Redirect to="/login" />;
  }

  return (
    <Fragment>
      <Row>
        <Col xs={24}>
          <Card
            type="inner"
            title="History Scan Produksi "
            extra={moment(new Date()).format("DD MMMM YYYY")}
          >
            <Row type="flex" justify="left">
              <Breadcrumb>
                <Breadcrumb.Item>
                  <Link to="/history-scan-produksi">Kembali</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>Edit History Scan Produksi</Breadcrumb.Item>
              </Breadcrumb>
            </Row>
          </Card>
        </Col>
      </Row>
      <Content className="content">
        <Row>
          <Col xs={24}>
            <Card className="body-data">
              <Form {...layout} name="control-hooks" onFinish={onSaveData}>
                <Form.Item
                  required
                  label="Item Number"
                  validateStatus={error && error.item_number ? "error" : false}
                  help={
                    error && error.item_number ? error.item_number[0] : false
                  }
                >
                  <Input
                    disabled
                    value={data.item_number}
                    onChange={(e) =>
                      handleChange("item_number", e.target.value)
                    }
                  />
                </Form.Item>
                <Form.Item
                  required
                  label="Qty"
                  validateStatus={error && error.qty ? "error" : false}
                  help={error && error.qty ? error.qty[0] : false}
                >
                  <Input
                    value={data.qty}
                    onChange={(e) => handleChange("qty", e.target.value)}
                  />
                </Form.Item>
                <Form.Item
                  required
                  label="Unit"
                  validateStatus={error && error.unit ? "error" : false}
                  help={error && error.unit ? error.unit[0] : false}
                >
                  <Input
                    value={data.unit}
                    onChange={(e) => handleChange("unit", e.target.value)}
                  />
                </Form.Item>

                <Form.Item {...tailLayout}>
                  <Button
                    loading={loading}
                    type="primary"
                    htmlType="submit"
                    className="mr-button"
                  >
                    Submit
                  </Button>
                  <Button htmlType="reset" onClick={handleReset}>
                    Reset
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </Col>
        </Row>
      </Content>
    </Fragment>
  );
}

export default EditHistoryScanProduksi;
